import { withLazyFallback } from 'lib/hoc/withLazyFallback';

const NotFound = withLazyFallback(() => import('components/NotFound'));
const CPTCodes = withLazyFallback(
  () => import('components/admin/pages/Databank/CPTCodes/CPTCodes')
);
const DatabankDashboard = withLazyFallback(
  () => import('components/admin/pages/Databank/Dashboard')
);
const DatapointsTable = withLazyFallback(
  () => import('components/admin/pages/Databank/Datapoints/DatapointsTable')
);
const GrowthDataTable = withLazyFallback(
  () => import('components/admin/pages/Databank/GrowthData/GrowthDataTable')
);
const ICD10Codes = withLazyFallback(
  () => import('components/admin/pages/Databank/ICD10Codes/ICD10Codes')
);
const Landmarks = withLazyFallback(
  () => import('components/admin/pages/Databank/Landmarks/Landmarks')
);
const ModifiersTable = withLazyFallback(
  () => import('components/admin/pages/Databank/Modifiers/ModifiersTable')
);
const OccupationsTable = withLazyFallback(
  () => import('components/admin/pages/Databank/Occupations/OccupationsTable')
);
const SpecialtyTable = withLazyFallback(
  () => import('components/admin/pages/Databank/Specialty/SpecialtyTable')
);

const ADMIN_DATABANK = [
  {
    path: 'databank',
    element: <DatabankDashboard />,
    children: [
      { path: ':type', element: <DatapointsTable /> },
      { path: 'cpt-codes', element: <CPTCodes /> },
      { path: 'icd10-codes', element: <ICD10Codes /> },
      { path: 'occupations', element: <OccupationsTable /> },
      { path: 'growth_data', element: <GrowthDataTable /> },
      { path: 'landmarks', element: <Landmarks /> },
      { path: 'specialities', element: <SpecialtyTable /> },
      { path: 'modifiers', element: <ModifiersTable /> },
      { path: '*', element: <NotFound /> }
    ]
  }
];

export default ADMIN_DATABANK;
